import type { TableRecord } from '@powerportalspro/core';
import { RecordContext, useColumnValue } from '@powerportalspro/react';
import { ColumnStatusBadge } from '@powerportalspro/react-fluent';

// On a page the badge reads a <RecordContext> that loads its record from Dataverse. These two
// accounts are handed in through `loadedRecord` instead, so the sample shows both states without
// depending on data.
function account(id: string, name: string, state: number, stateLabel: string, status: number, statusLabel: string) {
  const record: TableRecord = {
    id,
    tableName: 'account',
    properties: {
      name: { $type: 14, value: name },
      statecode: { $type: 11, value: state },
      statuscode: { $type: 11, value: status },
    },
    formattedValues: { statecode: stateLabel, statuscode: statusLabel },
    isDirty: false,
  };
  return { id, record };
}

const accounts = [
  account('00000000-0000-0000-0000-00000000000a', 'Contoso Ltd', 0, 'Active', 1, 'Active'),
  account('00000000-0000-0000-0000-00000000000b', 'Fabrikam, Inc.', 1, 'Inactive', 2, 'Inactive'),
];

function AccountName() {
  const { raw: name } = useColumnValue<string>('name');
  return <strong>{name}</strong>;
}

export function DisplayValuesStatusBadgeSample() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {accounts.map(({ id, record }) => (
        <RecordContext
          key={id}
          table="account"
          id={id}
          loadedRecord={record}
          warnOnUnsavedChanges={false}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <AccountName />
            <ColumnStatusBadge />
          </div>
        </RecordContext>
      ))}
    </div>
  );
}
